module.exports = __webpack_public_path__ + "img/suc-icon-gift-dialog.bc2ce432.png";